/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import Play from '../../../assets/svg/play-arrow.svg';
import Pause from '../../../assets/svg/pause.svg';
import { media } from '../../../utils/media-queries';
import { useWindowSize } from '../../../hooks/useWindowSize';

const Video = ({
  videoSrc,
  videoPoster,
  title,
  minutes,
  seconds,
  videoModule = false,
}) => {
  const size = useWindowSize();
  const isMobile = size.width < 1024;

  const ref = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showText, setShowText] = useState(true);

  const playVideo = () => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) return ref.current.play();
    if (isPlaying) return ref.current.pause();
  };

  // useEffect(() => {
  //   ref.current.play();
  //   ref.current.pause();
  // }, []);

  return (
    <StyledVideo className="grid" onClick={playVideo}>
      <AnimatePresence>
        {showText && (
          <motion.div
            className="text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            exit={{ opacity: 0 }}
          >
            <button className="bold-small large" type="button">
              {isPlaying ? (
                <span>
                  <Pause />
                </span>
              ) : (
                <span>
                  <Play />
                </span>
              )}
              {isPlaying ? 'Pause' : 'Play'}
            </button>
            <div>
              <p className="title">{title}</p>
              <p>{`${
                minutes ? `${minutes} minute${minutes === 1 ? '' : 's'}` : ''
              } ${seconds} seconds`}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <figure
        onMouseEnter={() => setShowText(true)}
        onMouseOut={() => setShowText(!!isMobile)}
        onBlur={() => setShowText(!!isMobile)}
      >
        <button className="bold-small mobile" type="button">
          {isPlaying ? (
            <span>
              <Pause />
            </span>
          ) : (
            <span>
              <Play />
            </span>
          )}
          {isPlaying ? 'Pause' : 'Play'}
        </button>
        <video
          ref={ref}
          src={videoSrc}
          muted={!videoModule}
          playsInline={!videoModule}
          poster={videoPoster}
        />
      </figure>
    </StyledVideo>
  );
};

const StyledVideo = styled.section`
  margin-bottom: calc(var(--v-spacing-L) * 2);
  width: auto;
  cursor: pointer;

  figure {
    position: relative;
  }

  .text {
    color: var(--blue);
    margin: 0;
  }

  .large {
    display: none;
  }

  .mobile {
    margin: var(--v-spacing-S);
    color: white;
    display: block;
    position: absolute;
    span {
      padding-right: 10px;
      svg {
        height: 18px;
      }
    }
  }

  @media ${media.L} {
    position: relative;

    figure {
      grid-column: 1 / 21;
    }

    .mobile {
      display: none;
    }

    .large {
      display: block;
      color: white;
      padding-bottom: var(--spacing-XS);
      span {
        padding-right: 10px;
        svg {
          margin-bottom: 1px;
        }
      }
    }

    .text {
      z-index: 1;
      margin: var(--v-spacing-S);
      position: absolute;
      top: 0;
      left: 0;
      grid-column: 1 / 18;
      color: white;

      .title {
        font-family: var(--font-2);
      }
    }
  }
`;

Video.propTypes = {
  videoSrc: PropTypes.string,
  videoPoster: PropTypes.string,
  title: PropTypes.string,
  minutes: PropTypes.number,
  seconds: PropTypes.number,
  videoModule: PropTypes.bool,
};

export default Video;
